import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-alarm",
  templateUrl: "./med-icon-alarm.component.html",
})
export class MedIconAlarmComponent extends SvgMixinComponent {}
